export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult
  if (removedIndex === null && addedIndex === null) return arr

  const result = [...arr]
  let itemToAdd = payload

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0]
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd)
  }

  return result
}

export const generateItems = (count, creator) => {
  const result = []
  for (let i = 0; i < count; i++) {
    result.push(creator(i))
  }
  return result
}

export const cloneObjectJson = (object) => {
  return JSON.parse(JSON.stringify(object))
}

export const getRandomColor = () => {
    var o = Math.round, r = Math.random, s = 155;
    var rc = o(r()*s), gc = o(r()*s), bc = o(r()*s);
    return {
        color: 'rgba(' + rc + ',' + gc + ',' + bc + ', 1)',
        backgroundColor: 'rgba(' + rc + ',' + gc + ',' + bc + ', 0.4)'
    };
}


// WEBPACK FOOTER //
// ./modules/Home/views/src/utils/helper.js